
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const CreateService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <h1 className="font-poppins font-bold text-4xl mb-4">Create Service</h1>
          <p className="font-inter text-xl text-gray-600">
            Add a new service offering
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="font-poppins text-2xl">New Service</CardTitle>
            <CardDescription className="font-inter">
              Create a new service to offer
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-center py-8">
              <p className="text-gray-500 font-inter mb-4">
                Ready to create a new service offering?
              </p>
              <Button 
                onClick={() => navigate("/offer-service")}
                className="bg-anyskill-purple hover:bg-anyskill-purple/90"
              >
                Start Creating Service
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CreateService;
